import React, { Component } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import './scss/style.scss';
import { getMenuItems } from './services/core-service';

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const TheLayout = React.lazy(() => import('./containers/TheLayout'));

// Pages
const Login = React.lazy(() => import('./views/framework/pages/login/Login'));
const Register = React.lazy(() => import('./views/framework/pages/register/Register'));
const Page404 = React.lazy(() => import('./views/framework/pages/page404/Page404'));
const Page500 = React.lazy(() => import('./views/framework/pages/page500/Page500'));

const legacyAppUrl = process.env.REACT_APP_LEGACY_APP_URL;

class App extends Component {

  constructor(props) {
    super(props)
    this.state = {
      menuItems: [],
    };
  }

  async componentDidMount() { 
    let menuItems = await getMenuItems();
    let shouldRedirectToLegacyApp = menuItems.reduce(function(accumulator, menuItem) {
      return accumulator && menuItem.is_legacy;
    }, true);

    if(shouldRedirectToLegacyApp) {
      window.location.href = legacyAppUrl;
    } else {
      this.setState({menuItems : menuItems});
    }
  }

  render() {
    return (
      <HashRouter>
          <React.Suspense fallback={loading}>
            <Switch>
              <Route exact path="/login" name="Login Page" render={props => <Login {...props}/>} />
              <Route exact path="/register" name="Register Page" render={props => <Register {...props}/>} />
              <Route exact path="/404" name="Page 404" render={props => <Page404 {...props}/>} />
              <Route exact path="/500" name="Page 500" render={props => <Page500 {...props}/>} />
              <Route path="/" name="Home" render={props => <TheLayout {...props} menuItems={this.state.menuItems} />} />
            </Switch>
          </React.Suspense>
      </HashRouter>
    );
  }
}

export default App;
